/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_TimeoutInputs */

const de_commons_error_timeout = /** @type {(inputs: Commons_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitüberschreitung - bitte erneut versuchen`)
};

/** @type {(inputs: Commons_Error_TimeoutInputs) => LocalizedString} */
const en_commons_error_timeout = de_commons_error_timeout;

/**

* @param {Commons_Error_TimeoutInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_timeout = /** @type {((inputs?: Commons_Error_TimeoutInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_TimeoutInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_timeout(inputs)
	return en_commons_error_timeout(inputs)
});